import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchClients, type ClientListResult } from "../api/clients";

export function useClients(search?: string) {
  return useQuery<ClientListResult>({
    queryKey: ["clients", search ?? ""],
    queryFn: () => fetchClients(search),
    staleTime: 60_000,
    // Typing must narrow the visible rows, not blink a skeleton per key.
    placeholderData: keepPreviousData,
  });
}
